import { BoardMarketing } from "../../components/Graphics";

export const Marketing = () => {
  return <BoardMarketing />;
};
